import { Flex, Text } from '@chakra-ui/react';
import ReferenceRating from 'components/ReferenceRating';
import ReferenceRatingComment from 'components/ReferenceRatingComment';
import RatingsDescription from 'components/RatingDescription';

const RatingContainer = ({
  title,
  ratingKey,
  value,
  commentValue,
  descriptions,
  setFieldValue,
}: RatingContainerProps): JSX.Element => {
  return (
    <Flex direction="column" bg="white" width="100%" p={4} mb={3} mt={6}>
      <Text
        fontWeight={700}
        fontSize="16px"
        lineHeight="19.2px"
        letterSpacing="3%"
        mb={4}
      >
        {title}
      </Text>
      <ReferenceRating
        rating={ratingKey}
        value={value}
        setFieldValue={setFieldValue}
      />
      <Flex direction="row" justifyContent="space-between" mb={4}>
        <RatingsDescription activeValue={1} value={value}>
          {descriptions.low.map((text, i) => (
            <p key={`${ratingKey}-low-${i}`}>{text}</p>
          ))}
        </RatingsDescription>
        <RatingsDescription
          activeValue={4}
          value={value}
          flex={0.34}
          textAlign="center"
        >
          {descriptions.medium.map((text, i) => (
            <p key={`${ratingKey}-medium-${i}`}>{text}</p>
          ))}
        </RatingsDescription>
        <RatingsDescription activeValue={7} value={value} textAlign="end">
          {descriptions.high.map((text, i) => (
            <p key={`${ratingKey}-high-${i}`}>{text}</p>
          ))}
        </RatingsDescription>
      </Flex>
      <ReferenceRatingComment
        comment={`${ratingKey}Comment`}
        value={commentValue}
        setFieldValue={setFieldValue}
      />
    </Flex>
  );
};

export default RatingContainer;
